import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { UpdateBatchBody } from "@shared-kernel/application/ports/educational-advisor/educational-advisor-repository";

export const updateBatch = createAsyncThunk<void, UpdateBatchBody, { extra: Partial<Dependencies> }>(
  "batches/updateBatch",
  async (body: UpdateBatchBody, { extra: { educationalAdvisorRepository } }) => {
    return educationalAdvisorRepository!.updateBatch(body);
  },
);

export const resetUpdateBatch = createAction("batches/resetUpdateBatch");
